import { render, staticRenderFns } from "./createProductsFirstBySupplier.vue?vue&type=template&id=5303d7f8&scoped=true"
import script from "./createProductsFirstBySupplier.vue?vue&type=script&lang=js"
export * from "./createProductsFirstBySupplier.vue?vue&type=script&lang=js"
import style0 from "./createProductsFirstBySupplier.vue?vue&type=style&index=0&id=5303d7f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5303d7f8",
  null
  
)

export default component.exports